// Get a reference to the parent script element in order to read its attributes
const AIScript = {dataset: {logging: false}};
/*
 * We need to detect firefox in order to include a shim for a bug affecting
 * elements with the contenteditable attribute.
 */
const FF = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

/*
 * Chat component class
 *
 *
 */

class AIChat extends HTMLElement {
  static get observedAttributes() { return ['theme_src']; }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'theme_src':
        this.applyCSSFile(newValue);
        break;
      default:

    }
  }
  constructor(){
    super();
    // Place holder text until agent profile loads.
    this._dfltHdr = 'Start Conversation';
    this._welcome = `
<p>Welcome to Chat!</p>
<div>What can I help you with today?</div>
`
    this._dfltNudge = `
Hello, how can<br>
we help you today?<br>
<span>Chat with an Agent Now ${AIChatIcons.arrow}</span>
`
    // Place holder image until agent profile loads.
    this._dfltAgntImg = 'data:image/svg+xml;utf8,' + AIChatIcons.agent_outline;

    this._chatSID = null;
    this._cvnClosed = false;

    // Convert JavaScript Style import to a CSS import once CSS imports are efficient
    let s = document.createElement('style');
    s.innerText = AIStyles;

    // Check if there is a ui state set in local storage and set accordingly;
    let ui_state_open = false;
    let temp = this.getStored(AIChat.gUI_STATE_NAME);
    if (temp !== null) {
      ui_state_open = temp == "true";
    }

    //set up toggle checkbox with visibility handled with css
    let tgl = document.createElement('input');
    tgl.type = 'checkbox';
    tgl.id = 'toggle';
    tgl.classList.add('hidden');// Hide the checkbox, and toggle with HTML labels
    tgl.checked = ui_state_open;// Set checkbox to previous state if any.
    tgl.onchange = this.chatToggled.bind(this);// Events to trigger when chat is opened or closed
    document.body.dataset.chat_open=ui_state_open;// Set data-chat_open attribute on page body to help correct for iOS peculiarities.

    //build component segments set to temporary variables.
    let b = this._body = document.createElement('chat-body');// Chat body

    let h = this._header = document.createElement('header');// Chat header
    let i = this._agtImg = document.createElement('img');// Agent profile image
    let nm = this._agtName = document.createElement('h3');// Agent name container
    let r = this._agtRole = document.createElement('div');// Agent role container

    let eb = this._endBtn = document.createElement('label');// End Chat Button
    eb.id = 'chat_end';
    eb.setAttribute('for', 'cnfm_end_tgl');
    eb.classList.add("hidden");
    eb.innerHTML = 'End Chat';

    let x = document.createElement('label');// Close icon
    x.innerHTML = AIChatIcons.x;
    x.setAttribute('for', 'toggle');

    h.append(i,nm,r,eb,x);//Add header segments to the chat header

    let hst = this._history = document.createElement('main');

    let f = document.createElement('footer');// Chat Footer

    // Set up growing chat text input area
    //TODO: add text max length
    let ci = this._chatInput = document.createElement('div');// Chat input
    ci.setAttribute('contenteditable','true');
    ci.id = 'input';
    //Set up key input handling. (Much more is needed for Firefox due to a bug.)
    ci.addEventListener('keypress', e => {
      if(e.shiftKey) return; // Keep default behavior if shift key is down
      if(e.which == 13) { // Otherwise ssend the message when enter is hit.
        e.preventDefault();
        this.send();
      }
    });
//Firefox shim
//TODO: Extract shim to script file for possible reuse
    if(FF){
      function bsp(carat){//Handle behavior when Backspace is pressed
        let str = ci.innerText;
        ci.innerText = str.slice(0,carat - 1);
      }
      function del(carat){//Handle behavior when Delete is pressed
        ci.innerText = str.slice(0,carat - 1) + str.slice(carat);
      }
      function drp(sel){//Handle behavior when text is cut
        ci.innerText = str.slice(0,sel.pos) + str.slice(sel.end);
      }
      ci.addEventListener('keydown', e => {//Handle user inputs when a selection is highlighted
        let sel = window.getSelection();
        let fn;
        // Set whick handler function will be invoked
        switch (e.which) {
          case 8:
            fn = 'bsp'; // Backspace
            break;
          case 46:
            fn = 'del' // Delete
            break;
        }
        if(sel.type === 'Range'){
          if(fn) fn = 'drp'; // Cut (drop)
          else fn = 'rpl'; // Replace with new text
        }
        if(fn){//Calculate range and carat position, then invoke the selected function
          let crt = Math.min(sel.anchorOffset,sel.focusOffset);// Carat position after deletion
          let end = Math.max(sel.anchorOffset,sel.focusOffset);// End of selection
          if(!crt && !end) return;
          let str = ci.innerText;
          switch (fn) {
            case 'bsp':
              if(crt)crt--;
              ci.innerText = str.slice(0, crt) + str.slice(end);
              break;
            case 'del':
              ci.innerText = str.slice(0,crt) + str.slice(end + 1);
              break;
            case 'drp':
              ci.innerText = str.slice(0,crt) + str.slice(end);
              break;
            case 'rpl':
              ci.innerText = str.slice(0,crt) + str.slice(end);
              break;
          }

          //set cursor position and reset focus and the range
          let range = document.createRange();
          range.setStart(ci.firstChild, crt);
          range.collapse(true);
          sel.removeAllRanges()
          sel.addRange(range)
          ci.focus();
        }
      });
    }


    // Create button icon to submit text.
    let sb = this._chatButton = document.createElement('div');
    sb.id = 'send_btn';
    sb.innerHTML = AIChatIcons.send;
    sb.onclick = this.send.bind(this);
    f.append(ci,sb);// Add Chat input and submit button to the footer

    //Confirm toggle
    let ctgl = document.createElement('input');
    ctgl.type = 'checkbox';
    ctgl.id = 'cnfm_end_tgl';
    ctgl.classList.add('hidden');

    //End Chat Confimation
    let cfrm = document.createElement('div');
    cfrm.id = 'cfrm_end';
    let cfrm_msg = document.createElement('chat-msg');
    let cfrm_btns = document.createElement('div');
    let cfrm_no = document.createElement('label');
    cfrm_no.innerText = 'NO';
    cfrm_no.classList.add("no");
    let cfrm_yes = document.createElement('label');
    cfrm_yes.innerText = 'YES';
    cfrm_yes.classList.add("yes");
    cfrm_yes.onclick = this.endChat.bind(this);
    cfrm_yes.setAttribute('for', 'cnfm_end_tgl');
    cfrm_no.setAttribute('for', 'cnfm_end_tgl');
    cfrm_msg.innerHTML = 'Are you sure you want to end the chat?';
    cfrm_msg.classList.add('system');
    cfrm_btns.append(cfrm_yes, cfrm_no);
    cfrm.append(cfrm_msg, cfrm_btns);
    b.append(h,hst,f,ctgl,cfrm);// Add the header, chat history and footer to the chat body

//TODO Make popover its own component.

    /*
     * Create a popup prompt to invite the user to toggle the chat component
     * Behavior is controlled by CSS
     */
    let n = document.createElement('label');
    n.classList.add('nudge');
    n.setAttribute('for', 'toggle');
    let pc = this._nudge = document.createElement('div');
    pc.innerHTML = this._dfltNudge;
    n.innerHTML +=`
${AIChatIcons.tail}
`;
n.prepend(pc);

    //Create a button icon to toggle the chat UI's visibility
    let icn = document.createElement('label');
    icn.id = 'chat_btn';
    icn.setAttribute('for', 'toggle');
    icn.innerHTML = AIChatIcons.bubble+AIChatIcons.close;

    // Create a shadow DOM root element to encapsuleate the CSS
    let sr = this.attachShadow({mode: 'open'});
    // Add the stylesheet, togglecontrol, nudge, chat body, and chat icon button to the shadow root.
    sr.append(s,tgl,n,b,icn);

    this.msgQueue = [];
    this._setEnv();//set logging and mobile environment
  }

  chatToggled(e) {
    let is_open = e.target.checked;
    this.setInLocalStorage(AIChat.gUI_STATE_NAME, is_open);

    let chatId = this.getStored(AIChat.gCHAT_ID_NAME)
    if (this._cvnClosed && !chatId) {
      this._cvnClosed = false;
      this._history.innerHTML = "";
      this.welcome();
    }
  }

  //Set up to be done when the component is loaded to the page.
  connectedCallback(){
    this.style.setProperty("visibility", "hidden");//hide until theme is applied.
    this.headerContent = this._dfltHdr;
    this.getSessionInfo(); //extract session info from the url

    this.debug_log("== AutoID Chat == Built: " + AIChat.ai_build_date);
    //Apply custom theme if provided
    this.applyTheme();
    // if we have the secure chat code, use that to get the history
    // and render the ui based on its status
    //
    if(!this._chatID) this._chatID = this.getStored(AIChat.gCHAT_ID_NAME);
    let chatId = this._chatID;
    if (chatId) {
      this.loadChatHistory(chatId)
      this.connectSocket(chatId);
      // this.initWebSocket();
    } else {
      this.welcome();
    }
  }

  // Session info is used to link the user navigating on the site to the chat.
  getSessionInfo() {
    /*
     * TODO: The URL should probably be set as an observed attribute of the
     * component, rather than reading from the script tag directly.
     */
    if (AIScript === null) {//Check that Script tag is accessible
      this.debug_log('[AI chat] Not able to locate chat ui script')
      return
    }

    // these parameters need to get passed down to the AI servers
    const src = AIScript.getAttribute('src');
    // get parameters from the url and pass to the AI servers
    this.ai = {
      gid: this.getURLParam(src, 'gid'),
      domain: this.getURLParam(src, 'd'),
      domainUuid: this.getURLParam(src, 'duuid'),
      pid: this.getURLParam(src, 'pid'),
      sid: this.getURLParam(src, 'sid')
    }
    this._dbg_mode = (this.getURLParam(src, 'aidebug') === '1');

    this.debug_log(`[AI chat] gid: ${this.ai.gid}`)
    this.debug_log(`[AI chat] domain: ${this.ai.domain}`)
    this.debug_log(`[AI chat] domain_uuid: ${this.ai.domainUuid}`)
    this.debug_log(`[AI chat] page_id: ${this.ai.pid}`)
    this.debug_log(`[AI chat] session_id: ${this.ai.sid}`)
    this.debug_log(`[AI chat] debugMode: ${this._dbg_mode}`)
  }

  //Read and return a parameter from a URL
  getURLParam(sr, name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "i"),
    results = regex.exec(sr);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  // Retrieve chat history from chat server and populate
  async loadChatHistory(chatId) {
    if (typeof chatId === 'string' ) {
      let config = {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' },
        body: JSON.stringify({"chatId":chatId})
      };
      let protocol = ('https:' == document.location.protocol) ? 'https' : 'http'
      let uri = `${protocol}://${AIChat.TEXT_URI}/chat/history`
      try {
        let res = await fetch(uri, config);


        //Fall back to the welcome message if no session is found
        if (res.status === 404) {
          this.cleanup()
          this.welcome()
          return
        }

        let historicData =  await res.json();
        if (historicData.status.toLowerCase() === 'c') {
         this.chatEnded();
        }
        else {
          this.loadHistory( historicData.history )
        }
      } catch (error) {
        console.log('Error getting chat history: ' + error.message);
      }
    }
  }

  //Handle socket closure.
  socketClosed(e){
    console.log('closing ' + e.code);
    if (e.code != 1000) {
      // Error code 1000 means that the connection was closed normally
      console.log('Web socket closed abnormally: ' + e.code)
    }

    if (! this._convoClosed){
      //Avoid an infinite loop of multiple connection attempts
      this._attempts=this._attempts||0;
      this._attempts++;
      // force clients to reconnect when not closed normally.
      // need to handle situations so we can reconnect to the same chat etc
      if(!this.reconect) this.reconect = setTimeout(function() {
        console.log('[Ai chat] web socket reconnect attempt');
        this.connectSocket();
        this.reconect = null;
      }.bind(this), 3000 * this._attempts^1.5);
    } else {
      this._attempts = 0;
    }
  }

  /*
   * We'll add the actual functionality of the end button in the future.
   */
  async endChat(){
    if (typeof this._chatID === 'string' ) {
      let config = {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' },
        body: JSON.stringify({"chatId": this._chatID})
      };
      let protocol = ('https:' == document.location.protocol) ? 'https' : 'http'
      let uri = `${protocol}://${AIChat.TEXT_URI}/chat/close`
      try {
        let res = await fetch(uri, config);


        // //Fall back to the welcome message if no session is found
        // if (res.status === 404) {
        //   this.cleanup()
        //   this.welcome()
        //   return
        // }
        //
        // let historicData =  await res.json();
        // if (historicData.status.toLowerCase() === 'c') {
        //  this.chatEnded();
        // }
        // else {
        //   this.loadHistory( historicData.history )
        // }
      } catch (error) {
        console.log('Error getting chat history: ' + error.message);
      }
    }
  }

  // Handle closure of chat session.
  chatEnded() {
    this.cleanup()
    this._history.innerHTML = "";
    this.display("This conversation has closed.", "system");
    this._cvnClosed = true;
  }

  // Reset default states and close socket.
  cleanup() {
    this._chatSID = null
    this._chatID = null
    this._endBtn.classList.add("hidden");//Hide end chat button
    this.current_agent_id = null;
    this.removeFromLocalStorage(AIChat.gCHAT_ID_NAME)
    this.removeFromLocalStorage(AIChat.gUI_STATE_NAME);
    this.headerContent = this._dfltHdr;
    this._convoClosed = true;
    if (this.reconect) {
      clearTimeout(this.reconect);
    }
    this.socket.close();
  }

  loadHistory(data) {
    if (data.length === 0) {
      this.welcome();
      return
    }

    for (let i = 0; i < data.length; i++) {
      let temp = data[i]
      if (temp.user_type === 'agent') {
        this.agentConnected(temp.user_id, temp.agentFirstName);
        this.display(temp.message, "agent", temp.message_time);
      }
      else if (temp.user_type === 'visitor') {
        this.display(temp.message, "user", temp.message_time);
      }
    }
  }

  //Connect Web Socket
  connectSocket(){
    let protocol = ('https:' == document.location.protocol)?"wss":"ws";
    let uri = `${protocol}://${AIChat.TEXT_URI}`;

    this.socket = new WebSocket(uri);
    let $this = this; //Binding the nested functions was getting complicated.
    this.socket.onopen = function () {//If Session ID is not set within the set time, log the timeout.
      let timeout = 10000;
      setTimeout(() => {
        if( $this._chatSID === null ) console.log(`[AI chat] socket timeout: Session ID was not provided within ${timeout/1000} seconds.`);
      },timeout);
    };
    this.socket.onmessage = this.receive.bind(this);
    this.socket.onerror = e=>console.log(e);
    this.socket.onclose = this.socketClosed.bind(this);
  }

  /*
   * Set the header contend when Agent informatin isn't available yet.
   */
  set headerContent(content){
    this.agentInfo(content,'','');
  }

  /*
   * Message to display on loading a new chat component;
   */
  async welcome(){
    let d = await ai_delay(0.2);
    this.display(this._welcome);
  }

  /*
   * Load the agent's name role and image to the chat header
   */
  agentInfo(name, img ){
    this._agtName.innerHTML = name;
    if(img)this._agtImg.src = img;
    else if(this._agtImg.hasAttribute('src'))this._agtImg.removeAttribute('src');
  }


  /*
   * Send a message to the AI chat server
   */
  async send(){
    if(this._cvnClosed) { // Reset the UI if this is a new conversation
      this._history.innerHTML = "";
      this._cvnClosed = false;
    }

    let msg = this._chatInput.innerText;// Get the message from the input
    this._chatInput.innerText='';// Clear the input
    this._chatInput.focus();// Refocus the input

    if(msg) {// If the message actually cantains text format, call the send function, and then, display it.
      let data = {
        "event":"chatMessage",
        "message": msg,
        "time": new Date().getTime()
      };
      await this.sendWSMessage(data);
      this.display(msg,'user');
    }
  }

  /*
   * Handle session info and send the messages
   * It's asychronous in case the connection hasn't been established yet.
   */
  sendWSMessage(message) {
    // When this is a new conversation we need to create socket connection and send details of user.
    if (this._chatSID === null) {
      if(!this.msgQueue.length){
        this.connectSocket();
        message.ai = this.ai;
      }
      this.msgQueue.push(message);
    } else {
      // Note: since it's a socket connection we shouldn't need to resend these every time, but that probably requires a change to the socket server
      // Handle session state and IDs
      // let chatId = this.getStored(AIChatConfig.gCHAT_ID_NAME) || this._chatID;
      message.userState = "ready";
      message.sessionId = this._chatSID;
      message.chatSid = this._chatID;

      // for new chat conversation, this will be null and server will provide it.
      this.socket.send(JSON.stringify(message));
    }
  }

  /*
   * Handle information recieved from the socket
   */
  receive(res){
    let data = JSON.parse(res.data);
    if (typeof data.event === 'string') {
      const event = data.event.toLowerCase();
      switch (event) {
        case 'registration': //Store relevant data on registration message
          this._chatSID = data.sessionId;
          this.debug_log('[AI chat] socket session id set: ' + this._chatSID);
          this._convoClosed = false;

          // Send any messages that were queud before the socket connected
          while (this.msgQueue.length) this.sendWSMessage(this.msgQueue.shift());
          if(!this._chatID) this._chatID = this.getStored(AIChat.gCHAT_ID_NAME);
          let chatId = this._chatID;
          if (chatId) {
            // 'reconnect' a visitor to their conversation
            this.sendWSMessage( {
              "event":"connectConversation"
            });
            if(this._chatID)this._endBtn.classList.remove("hidden");//Show end chat button
          }
          break;
        case 'chatresponse':
          if (data.chatId && data.chatId!=this._chatID) {
            // store the chat id, maybe verify the id matches the stored chatId
            console.log('chat id: ' + data.chatId);
            this._endBtn.classList.remove("hidden");//Show end chat button
            this._chatID = data.chatId;
            this.setInLocalStorage(AIChat.gCHAT_ID_NAME, data.chatId)
          }
          if (data.agentMessage) { //Hanle agent messages load agent info to header and display any messages.
            this.agentConnected(data.agentUserId, data.agentFirstName, data.agentImg, data.agentTitle);//NOTE: agentTitle might be incorrect, I didn't get any examples with job title data.
            this.display(data.agentMessage, "agent");
          }
          break;
        case 'conversation_closed':
          this.chatEnded()
          break;
        default:
          console.log(`[AI chat] unhandled socket event: ${event}`)

      }
    }
  }

  // Return a value from local storage
  getStored(key) {
    let v = null
    try {
      if (this.localStorageIsAvail()) {
        v = window.localStorage.getItem(key);
      }
      else {
        console.log('[AI chat] local storage NOT available.')
      }
    }
    catch(e){
      console.error(e);
    }
    return v
  }

  // Store a value in local storage
  setInLocalStorage(key, value) {
    try {
      if (this.localStorageIsAvail()) {
        window.localStorage.setItem(key, value)
      }
      else {
        console.log('[AI chat] local storage NOT available.')
      }
    }
    catch(e){
      console.error(e);
    }
  }

  // Delete a value from local storage
  removeFromLocalStorage(key) {
    try {
      if (this.localStorageIsAvail()) {
        window.localStorage.removeItem(key)
      }
      else {
        console.log('[AI chat] local storage NOT available.')
      }
    }
    catch(e){
      console.error(e);
    }
  }

  // Check availability of local storage
  localStorageIsAvail(){
    let isAvail = false;

    try {
      let test = new Date;
      let storage = window.localStorage
      storage.setItem(test, test);
      isAvail = storage.getItem(test) == test;
      storage.removeItem(test);
    } catch (exception) {}

    return isAvail
  }

  display(msg, type, time){
    let m = document.createElement('chat-msg');
    m.classList.add(type||'system');
    m.setAttribute('time', time||new Date().toLocaleTimeString());
    m.innerHTML = msg;
    this._history.append(m);

    //Scroll to bottom of messages.
    let h = this._history;
    h.scrollTo(0,h.scrollHeight - h.clientHeight);
  }

  // Toggle debug logging
  toggleLogging(){
    this._logging = !this._logging;
  }

  /*
   * Set header values and inform the user if the agent disconnects
   */
  agentConnected(agent_id, firstname, img='', title='Online Chat Specialist'){
    if(this.current_agent_id == agent_id) return;
    this.current_agent_id = agent_id;
    let name = `${firstname}`;
    if(!img) img = this._dfltAgntImg.replace('class', `fill="${ getComputedStyle(this).getPropertyValue('--theme-agent').trim().replace('#','%23') }" class`);
    this.agentInfo(name, img);
    this.display(`<p>An agent has connected.</p><div>${name} is available to help.</div>`, 'system');
  }

  /*
   * Reset header and inform the user if the agent disconnects
   */
  agentDisonnected(){
    this.headerContent = this._dfltHdrTxt;
    this.display(`<p>${name} has disconnected.</p>`, 'system');
  }

  /*
   * Overrides style variables from a css file
   */
  applyCSSFile(href){
    let t = this._theme = document.createElement('link')
    t.rel="stylesheet";
    t.type="text/css";
    t.href=href;
    this.shadowRoot.append(t);
  }

  async applyTheme(branding){
    //Set custom theme if a source id provided in the script's data-theme attribute.
    if(!branding && document.getElementById('aichat_init').dataset.theme){
      this.setAttribute('theme_src',document.getElementById('aichat_init').dataset.theme);
    }
    try {
      let theme;
      if(branding){
        theme = branding;
      } else {
        let config = {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' },
          body: JSON.stringify({domain: this.ai.domain})
        };
        let protocol = ('https:' == document.location.protocol) ? 'https' : 'http'
        let uri = `${protocol}://${AIChat.TEXT_URI}/chat/config`;
        let res = await fetch(uri, config);
        let json = await  res.json();
        theme = json.branding || {};
      }
      for(let key in theme) switch (key) {
        case 'styling':
          for(let cv in theme[key]) this.style.setProperty(cv, theme[key][cv]);
          break;
        case 'send-icon-id':
          let si = this.shadowRoot.getElementById('send_icon');
          if(this.shadowRoot.getElementById(theme[key])) si.setAttribute('href', `#${theme[key]}`);
          break;
        case 'chat-icon-id':

          let ci = this.shadowRoot.getElementById('chat_icon');
          if(this.shadowRoot.getElementById(theme[key])) ci.setAttribute('href', `#${theme[key]}`);
          break;
        case 'header-html':
          this.headerContent= theme[key];
          break;
        case 'welcome-html':
          this._welcome = theme[key];
          break;
        case 'popup-html':
          this._nudge.innerHTML = theme[key];
          break;
        default:
          this.debug_log(`Received unknown theme variable $(key)`);
      }
      this.style.setProperty("visibility", "visible");
    } catch (error) {
      this.debug_log('Error getting chat theme: ' + error.message);
    }
  }

  /*
   * Will log to the console only when debugging is turned on.
   */
  debug_log(msg){
    if (this._dbg_mode) {
      console.log(msg);
    }
  }
/*
 * Set up logging and for mobile viewport management
 */
  _setEnv(){
    this._logging = AIScript.dataset.logging !== 'true';
    if(AIScript.dataset.viewport !== 'manual'){
      let isMBL = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/.test(navigator.userAgent));
      if(isMBL){
        let st = document.createElement('style');
        st.innerText = `
body[data-chat_open=true] {
  bottom: 0;
  overflow: hidden;
}`;
        document.head.append(st);
        let vp = document.head.querySelector('meta[name=viewport]');
        let isIOS = (/iPad|iPhone|iPod/.test(navigator.userAgent));
        if(!vp){
          vp = document.createElement('meta');
          vp.name = 'viewport';
          document.head.append(vp);
          if(!isIOS) vp.setAttribute('content', 'width=device-width, initial-scale=1');
        }
        if(isIOS){
          vp.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no');
        }
      }
    }
  }
}

AIChat.ai_build_date = '%build_date%';
AIChat.gCHAT_ID_NAME = 'aiChatId';
AIChat.gUI_STATE_NAME = 'aiChatId_ui_state';
AIChat.TEXT_URI = '%TEXT_SERVER%.autoid.com%TEXT_SERVER_PORT%';
AIChat.MAX_MESSAGE_LENGTH = 500;

/*
 * A modification of AIChat for themeing tools.
 *
 * Individual theme defaults can be overridden by calling .style.add('--variable-name','value')
 * on areference to the aic-themer element.
 *
 * A css file can be used to set all filse at once by setting theme_src to its url;
 */
class AIChatThemer extends AIChat {
  constructor(){
    super();
    //remove unused functions
    delete this.getSessionInfo;
    delete this.getURLParam;
    delete this.loadChatHistory;
    delete this.socketClosed;
    delete this.cleanup;
    delete this.loadHistory;
    delete this.connectSocket;
    delete this.sendWSMessage;
    delete this.receive;
    delete this.getStored;
    delete this.setInLocalStorage;
    delete this.removeFromLocalStorage;
    delete this.localStorageIsAvail;
    delete this.getStored;
  }

  //Override connectedCallback to remove communication features
  connectedCallback(){
    this.shadowRoot.querySelector('.nudge').removeAttribute('for');
    this.headerContent = this._dfltHdr;
    //display examples of different message types for themeing.
    this.display('This is a system message','system');
    this.display('This is an agent message','agent');
    this.display('This is a user message','user');
    this.classList.add('themer');
    this._endBtn.classList.remove("hidden");//Show end chat button
    // let branding = {styling:{}}
    // branding.styling["--theme-header-bg"] = 'red';
    // this.applyTheme(branding);
  }

  // Override endChat
  endChat(){
  }

  // Override chatEnded (in case someone decides to the text a css variable)
  chatEnded() {
    this._history.innerHTML = "";
    this.display("This conversation has closed.", "system");
    this._cvnClosed = true;
  }

  //Override send so it doesn't initialize a socket connection.
  send(){
    let msg = this._chatInput.innerText;// Get the message from the input
    this._chatInput.innerText='';// Clear the input
    this._chatInput.focus();// Refocus the input

    if(msg) {// If the message actually cantains text format, call the send function, and then, display it.
      let data = {
        "event":"chatMessage",
        "message": msg,
        "time": new Date().getTime()
      };
      this.display(msg,'user');
    }
  }
}
customElements.define('preview-aichat', AIChatThemer);

/*
 * Styles for AutoID Chat
 * Currently coverted to JavaScript because ES6 impports are very efficient, and
 * CSS @import is still quite inneficient.
 *
 * Reccomend switching back once browser implementation of CSS @import catches up
 */
let AIStyles = `:host {
  /* Default values that can be overriden in a seperate file */
  --theme-buttons: #0384e0;
  --theme-header-bg: #434A54;
  --theme-header-fc: white;
  --theme-end-chat-bg: var(--theme-header-bg);
  --theme-end-chat-fc: var(--theme-header-fc);
  --theme-end-chat-brdr: var(--theme-header-fc);
  --theme-x-color: var(--theme-header-fc);
  --theme-agent: var(--theme-header-fc);
  --theme-body-bg: white;
  --theme-footer-bg: #F5F5F5;
  --theme-footerer-fc: black;
  --theme-sys-bg: white;
  --theme-sys-fc: black;
  --theme-sys-p: #007BFF;
  --theme-agt-bg: #E5E5E5;
  --theme-agt-fc: var(--theme-sys-fc);
  --theme-usr-bg: #3d8bff;
  --theme-usr-fc: white;
  --theme-chat-icon-bg: var(--theme-buttons);
  --theme-chat-icon-color: var(--theme-header-fc);
  --theme-chat-icon-size: 60px;
  --theme-send-color: var(--theme-buttons);
  --theme-pop-bg: var(--theme-header-fc);
  --theme-pop-fc: var(--theme-chat-icon-bg);
  --theme-pop-border: var(--theme-pop-fc);
  --theme-pop-delay: 10s;
  --theme-pop-duration: 40s;
  --theme-cnfm-bg: #FFF;
  --theme-cnfm-fc: #777;
  --theme-cnfm-yes-bg: var(--theme-cnfm-bg);
  --theme-cnfm-yes-fc: var(--theme-cnfm-fc);
  --theme-cnfm-no-bg: var(--theme-cnfm-bg);
  --theme-cnfm-no-fc: var(--theme-cnfm-fc);
  --theme-display-chat-end: "block";

  /* Font values and fallbacks for the component */
  font-family: "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 15px;

  /* The component takes up the full page in front of the rest of the package
     but allows mouse events to pass to the underlying page */
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  pointer-events: none;

  /* Grid layout for the various pieces of the component */
  display: grid;
  grid-template-columns: 1fr 172px calc(208px - var(--theme-chat-icon-size)) var(--theme-chat-icon-size) 20px;
  grid-template-rows: 1fr minmax(190px, 490px) 107px 0.5em var(--theme-chat-icon-size) 1em;

  /* invisible border to fix a browser specific bug */
  border: 1px solid rgba(0,0,0,0);
}

/* All descendants of the outer element will intercept mouse events */
:host * {
  pointer-events: auto;
}

/* Styling for the component's header area */
header {
  background-color: var(--theme-header-bg);
  color: var(--theme-header-fc);
  padding-left: 2em;
  display:flex;
  align-items: center;
}

header div {
  padding-left: 1.5em;
  flex-grow: 1;
}

/* Hide profile picture if no src url is provided */
header img:not([src]){
  display:none;
}

header img {
  margin-right: 1em;
  height:30px;
}

#chat_end, chat-body {
  font-size: 0.9em;
  border-radius: 1em;
  padding: 0.5em;
  margin-right: 0.5em;
}

#chat_end {
  color: var(--theme-header-fc);
  display: var(--theme-display-chat-end);
  background-color: var(--theme-end-chat-bg);
  border: 2px solid var(--theme-end-chat-brdr);
}

label {
  cursor: pointer;
}

header label:not(#chat_end) {
  display: none;
}

/* Styles for the main chat interface area */
chat-body {
  grid-column: 2 /span 3;
  grid-row: 2 /span 2;
  background-color: var(--theme-body-bg);
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 20px 4px;
  border-radius: 0.5em;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template: auto 1fr auto / 1fr;
  height: 100%;
  overflow: hidden;
}

/* Styles for check box to control visibility */
input:not(:checked)~chat-body {
  display: none;
}

input:not(:checked)~#chat_btn #close {
  display: none;
}

input:checked~#chat_btn #bubble {
  display: none;
}

/* Vertical flex layout for scrolling message container */
main {
  grid-column: 1;
  grid-row: 2;
  overflow: auto;
}

/* */
#cfrm_end {
  z-index: 1000;
  grid-column: 1;
  grid-row: 2 /span 2;
  background-color: white;
  display:flex;
}

#cfrm_end div {
  display:flex;
  justify-content: space-around;
  padding: 0 5em 0 5em;
}

#cfrm_end label {
  border: 2px solid;
  font-weight: bold;
  text-align: center;
  width: 4em;
  height: 2em;
  line-height: 2em;
  border-radius: 1em;
}

#cfrm_end label.yes {
  background-color: var(--theme-cnfm-yes-bg);
  border-color: var(--theme-cnfm-yes-fc);
  color: var(--theme-cnfm-yes-fc);
}

#cfrm_end label.no {
  background-color: var(--theme-cnfm-no-bg);
  border-color: var(--theme-cnfm-no-fc);
  color: var(--theme-cnfm-no-fc);
}

#cnfm_end_tgl:not(:checked)~#cfrm_end {
  display:none;
}

main, #cfrm_end {
  padding: 0.5em;
  display: flex;
  flex-direction: column;
  gap: 1em;
  line-height: 1.25;
}

/* Message Styles */
chat-msg {
  border-radius: 0.5em;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  width: 75%;
  padding: 1em;
}

/* User and Agent Message Styles */
chat-msg:not(.system){
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

/* System Message Styles */
chat-msg.system {
  align-self: center;
  background-color: var(--theme-sys-bg);
  color: var(--theme-sys-fc);
}

/* Spacing and timestamps after messages */
chat-msg.show_details, chat-msg:last-child {
  position: relative;
  margin-bottom: 1.5em;
}

chat-msg.show_details:after, chat-msg:last-child:after {
  content: attr(agt-name) ' ' attr(time);
  position: absolute;
  bottom: -1.5em;
  left: 1em;
  font-size: 0.75em;
  color: black;
}

chat-msg:last-child:not(.old):after {
  animation: time_display;
  animation-duration: 30s;
}

/* System Message content Styles */
chat-msg p {
  color: var(--theme-sys-p);
  margin: 0;
  padding: 0;
  overflow-wrap: break-word;
}

/* Agent Message content Styles */
chat-msg.agent {
  align-self: start;
  background-color: var(--theme-agt-bg);
  color: var(--theme-agt-fc);
}

/* User Message content Styles */
chat-msg.user {
  align-self: flex-end;
  background-color: var(--theme-usr-bg);
  color: var(--theme-usr-fc);
}

/* Chat footer and input area styles */
footer {
  grid-column: 1;
  grid-row: 3;
  display: flex;
  align-items: center;
  background: var(--theme-footer-bg);
  padding: 1em;
  gap: 1em;
  line-height: 1.25;
  border-top: 1px solid var(--theme-header-bg);
}

/* Allow text input area to grow */
#input {
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial';
  height: -moz-fit-content;
  font-weight: 400;
  font-size: 15px;
  height: fit-content;
  flex-grow: 1;
  max-height: 1.5in;
  overflow-y: auto;
}

#input:focus {
  outline: none;
}

/* Text placeholder */
#input:empty:not(:focus):before {
  content:"Enter message here...";
  pointer-events: none;
}

/* Button Styles */
/* Align the send button */
#send_btn {
  display: flex;
  align-items: center;
}

/* Chat toggle */
#chat_btn {
  grid-column: 4;
  grid-row: 5;
}

/* Cursor for buttons */
.nudge, #send_btn, #chat_btn, button {
  cursor: pointer;
}

/* Send */
footer button {
  border: none;
  background-color: none;
}

/* Popup prompt */
input:checked~.nudge {
  display:none;
}

.nudge {
  transform: scale(0);
  opacity: 0;
  stroke: var(--theme-pop-border);
  grid-column: 3 /span 2;
  grid-row: 3 /span 2;
  fill: var(--theme-pop-bg);
  position: relative;
  animation: pop;
  animation-iteration-count: 1;
  animation-delay: var(--theme-pop-delay);
  animation-duration: var(--theme-pop-duration);
  transform-origin: 178px 100%;
  user-select: none;
  color: var(--theme-pop-fc);
  font-weight: 400;
  line-height: 1.5;
  border-radius: 5px;
  border: 1px solid var(--theme-pop-border);
  background: var(--theme-pop-bg);
  width: 100%;
  margin: 10px;
  clip-path: AIChatIcons.nudge;
}

.nudge #tail {
  position:absolute;
  width:20px;
  height: 6px;
  bottom:-6px;
  right: calc(var( --theme-chat-icon-size) / 2);
}

.nudge>div {
  position:absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 10px;
}

.nudge>div span {
  font.size: 0.9em;
  font-weight: 700;
  line-height: 2;
}

.arrow {
  fill: var(--theme-pop-fc);
}

#arrow {
  height: 0.75em;
}

.hidden {
  display: none;
}

/* Animation for popup prompt */
@keyframes pop {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  2% {
    transform: scale(1);
    opacity:1;
  }
  98% {
    transform: scale(1);
    opacity:1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}

/* Animation to display time under chat pessages */
@keyframes time_display {
  from {
    content: attr(agt-name) ' A few seconds ago.';
  }
  to {
    content: attr(agt-name) ' ' attr(time);
  }
}

/* Themer Component style overrides */
:host(.themer) {
  position:relative;
  display: grid;
  grid-template-columns:  148px var(--theme-chat-icon-size) 172px 20px;
  grid-template-rows: 597px 107px 0.5em var(--theme-chat-icon-size) 1em;
}

:host(.themer) chat-body {
  grid-column: 1 /span 3;
  grid-row: 1 /span 1;
  display: grid;
}

:host(.themer) #chat_btn {
  grid-column: 2;
  grid-row: 4;
}

:host(.themer) .nudge {
  grid-column: 1 /span 2;
  grid-row: 2 /span 2;
  transform: scale(1);
  animation: none;
  opacity: 1;
}

:host(.themer) input:checked~.nudge {
  display: block;
}



/* Mobile styles*/
@media screen and (hover: none) and (pointer: coarse) {
  :host{
    grid-template-rows: 0px 1fr 107px 0.5em var(--theme-chat-icon-size) 1em;
    height: 100%;
    width: 100%;
    border: none;
  }

  chat-body {
    grid-column: 1 /span 5;
    grid-row: 1 /span 6;
    box-shadow: none;
    border-radius: 0;
    height: 100%;
  }

  header div{
    flex-grow: 1;
  }

  #chat_end {
    color: var(--theme-header-fc);
    background-color: var(--theme-end-chat-bg);
    border: 2px solid var(--theme-end-chat-brdr);
    padding: 0.1em 0.5em 0.1em 0.5em;
    margin-right: 3em;
  }

  header label:not(#chat_end) {
    margin-right: 0.5em;
    display: var(--theme-display-chat-end);
    justify-self: flex-end;
    font-size: 3em;
  }

  .close-x {
    fill: var(--theme-header-fc);
  }

  input:checked~#chat_btn{
    display:none;
  }

  /* iOS specific styles */
  @supports (-webkit-touch-callout: none) {
    :host {
      top:0;
      left:0;
      bottom:0;
      height: 100%;
      width: 100%;
    }

    /* Adjust for the unusual behavior of ios keyboard */
    :host(:focus-within) {
      top: 40%;
      height: 60%;
    }
  }
}`

/*
 * SVG icons for AI Chat Component
 */
const AIChatIcons = {
  bubble: `
<svg id="bubble" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <g id="chat_icon_convo">
      <path d="M16 53 s6 0 10 -4 c28 6 32 -18 24 -25 c-18 -19 -46 5 -29 20 c-2 5 -3 5 -5 9" fill="none" stroke-width="4" stroke-linecap="round" />
      <path d="M67 65 s-3 -1 -5 -9 c5 -5 10 -20 -5 -28 c3 20 -15 30 -30 26 c10 10 18 9 27 7 c3 1 5 4 13 5 Z" stroke="none"/>
    </g>

    <path id="chat_icon_oval" d="M62 61 s-3 -1 -5 -9 c5 -5 10 -20 -5 -31  s-45 5 -30 29 c10 10 18 9 27 7 c3 1 5 4 13 5" stroke-width="5" stroke-linecap="round"/>

    <use id="chat_icon_oval_outline"  href="#chat_icon_oval" fill="none" />

    <path id="chat_icon_rect" d="M56 68 v-11 s8 0 9 -9 v-20 s0 -8 -9 -9 h-31 s-8 0 -9 9 v20 s0 8 9 9 h17 l13 11 Z" />
    <g id="chat_icon_rect_convo">
      <path d="M24 57 l11 -10 h14 s3 0 4 -4 v-19 s0 -3 -4 -4 h-28 s-3 0 -4 4 v19 s0 4 4 4 h4 Z M25 30 h20 M25 36 h15" fill="none" stroke-width="2" stroke-linecap="round"/>
      <path d="M57 69 v-8 s5 0 7 -7 v-17 s0 -5 -7 -7 v15 s0 7 -7 7 h-12 l-7 7 h14 l11 10 Z" />
    <g>
  </defs>
  <circle cx="40" cy="40" r="40" fill="var(--theme-chat-icon-bg)" />
  <use stroke="var(--theme-chat-icon-color)" fill="var(--theme-chat-icon-color)" id="chat_icon" href="#chat_icon_oval_outline" />
</svg>
`,
  close:`
<svg id="close" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="30" cy="30" r="30" class="close" r="40" fill="var(--theme-chat-icon-bg)"/>
  <path d="M17 43L43 17" stroke="var(--theme-chat-icon-color)"/>
  <path d="M43 43L17 17" stroke="var(--theme-chat-icon-color)"/>
</svg>
`,
  send:`
<svg id="send" width="29" height="29" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <path id="send_icon_solid" d="M5.15123 19.925L19.5004 13.3132C20.1665 13.0038 20.1665 11.9962 19.5004 11.6868L5.15123 5.07503C4.60851 4.81869 4.00822 5.25181 4.00822 5.8794L4 9.9543C4 10.3963 5.58885 11.947 6 12L16.3346 12.5L6 13C5.58885 13.0619 4 14.6037 4 15.0457L4.00822 19.1206C4.00822 19.7482 4.60851 20.1813 5.15123 19.925Z" stroke="none"/>
  </defs>
  <use id="send_icon" href="#send_icon_solid" fill="var(--theme-send-color)" stroke="var(--theme-send-color)" />
</svg>
`,
  agent_outline:`
<svg id="user" width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.7 14.25C13.3547 14.25 12.7078 15 10.5 15C8.29219 15 7.65 14.25 6.3 14.25C2.82187 14.25 0 17.0719 0 20.55V21.75C0 22.9922 1.00781 24 2.25 24H18.75C19.9922 24 21 22.9922 21 21.75V20.55C21 17.0719 18.1781 14.25 14.7 14.25ZM18.75 21.75H2.25V20.55C2.25 18.3188 4.06875 16.5 6.3 16.5C6.98437 16.5 8.09531 17.25 10.5 17.25C12.9234 17.25 14.0109 16.5 14.7 16.5C16.9312 16.5 18.75 18.3188 18.75 20.55V21.75ZM10.5 13.5C14.2266 13.5 17.25 10.4766 17.25 6.75C17.25 3.02344 14.2266 0 10.5 0C6.77344 0 3.75 3.02344 3.75 6.75C3.75 10.4766 6.77344 13.5 10.5 13.5ZM10.5 2.25C12.9797 2.25 15 4.27031 15 6.75C15 9.22969 12.9797 11.25 10.5 11.25C8.02031 11.25 6 9.22969 6 6.75C6 4.27031 8.02031 2.25 10.5 2.25Z" class="user"/>
</svg>
`,
  arrow:`
<svg id="arrow" width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.67746 1.69873L5.22254 1.13506C5.45335 0.896387 5.82656 0.896387 6.05491 1.13506L10.8281 6.06846C11.0589 6.30713 11.0589 6.69307 10.8281 6.9292L6.05491 11.8651C5.82411 12.1038 5.45089 12.1038 5.22254 11.8651L4.67746 11.3015C4.4442 11.0603 4.44911 10.6667 4.68728 10.4306L7.64598 7.51572H0.589286C0.262723 7.51572 0 7.24404 0 6.90635V6.09385C0 5.75615 0.262723 5.48447 0.589286 5.48447H7.64598L4.68728 2.56963C4.44665 2.3335 4.44174 1.93994 4.67746 1.69873Z" class="arrow" />
</svg>
`,
  tail:`
<svg id="tail" viewBox='0 0 20 6' >
  <path d="M0 0 l10 6 l10 -6" />
</svg>
`,
  x:`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.6979 8L14 12.3021L12.3021 14L8 9.6979L3.6979 14L2 12.3021L6.3021 8L2 3.6979L3.6979 2L8 6.3021L12.3021 2L14 3.6979L9.6979 8Z" fill="var(--theme-x-color)"/>
</svg>
`
}

//Auto deploy if not overridden.

function ai_delay(sec=0,rand){
  let s = sec * 1000;
  let delay;
  if(rand){
    delay = Math.floor(Math.random() * sec);
    if(!isNaN(rand)) delay += rand * 1000;
  }
  else delay = s;
  return new Promise(resolve => setTimeout(resolve, delay));
}

